(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-all-products-sort]');

    if (!select) return;

    const value = select.value;

    if (!value) return;

    const newUrl = new URL(window.location.href);

    newUrl.searchParams.set('sort_by', value);

    /*
      Reset to page 1 when changing the sort order.
      This prevents someone changing the sort while viewing
      page 3, 4, etc.
    */
    newUrl.searchParams.delete('page');

    window.location.href = newUrl.toString();
  });

  } catch(e) { console.error(e); }
})();
})();
